module.exports = __webpack_public_path__ + "static/4-4e8028ff302967051c4d470bfed872b4.svg";